/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceItem
 */
export interface InvoiceItem {
    /**
     * 
     * @type {string}
     * @memberof InvoiceItem
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceItem
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof InvoiceItem
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceItem
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceItem
     */
    id?: number;
}

/**
 * Check if a given object implements the InvoiceItem interface.
 */
export function instanceOfInvoiceItem(value: object): value is InvoiceItem {
    return true;
}

export function InvoiceItemFromJSON(json: any): InvoiceItem {
    return InvoiceItemFromJSONTyped(json, false);
}

export function InvoiceItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceItem {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'price': json['price'] == null ? undefined : json['price'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function InvoiceItemToJSON(json: any): InvoiceItem {
    return InvoiceItemToJSONTyped(json, false);
}

export function InvoiceItemToJSONTyped(value?: InvoiceItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'price': value['price'],
        'quantity': value['quantity'],
        'id': value['id'],
    };
}

